module.exports = __webpack_public_path__ + "img/granbretana.996e2266.jpg";